export default "__VITE_ASSET__HmBFlvDI__"